import { Filter as FilterIcon } from 'iconsax-react';
import type { Column } from '@tanstack/react-table';

import {
  Filter,
  FilterOptionItem,
  FilterOptionsList,
  FilterTrigger,
} from '@src/design-system/filter-new';
import { ConditionallyRenderedFilterPanel } from './conditionally-rendered-filter-panel';
import { Button } from '@src/design-system/button';
import { Badge } from '@src/design-system/badge';
import { useTableStates } from '@design-system/molecules/ticlick-table/hooks/use-table-states';
import { useTableViewHelpers } from '@src/design-system/molecules/ticlick-table/hooks/use-table-view-helpers';

export function ColumnHeaderFilterTrigger<TData>({
  column,
}: {
  column: Column<TData, unknown>;
}) {
  const { tableFilters } = useTableStates();
  const config = column.columnDef.meta?.columnFilter;

  const selectedCount = tableFilters?.staticFilters?.find(
    (f) => f.field === config?.facetName
  )?.value?.length;

  if (!config) return null;

  return (
    <Filter>
      <FilterTrigger asChild>
        <Button
          size='iconXs'
          variant='ghost'
          className='hover:bg-primary-100 relative hover:text-primary-900'
        >
          {!!selectedCount && (
            <Badge
              className='absolute top-0 left-0 rounded-full size-4! p-0 flex justify-center items-center text-xs text-white bg-primary-800'
              style={{ background: config.color }}
            >
              {selectedCount}
            </Badge>
          )}

          <FilterIcon
            size={16}
            variant='TwoTone'
          />
        </Button>
      </FilterTrigger>

      <FilterOptionsList
        align='end'
        alignOffset={-8}
        sideOffset={20}
        style={{ width: 250 }}
        className='p-0 w-auto'
        onClick={(e) => e.stopPropagation()}
      >
        <ConditionallyRenderedFilterPanel config={config} />
        <ClearFacetButton facetName={config.facetName} />
      </FilterOptionsList>
    </Filter>
  );
}

const ClearFacetButton = ({ facetName }: { facetName: string }) => {
  const { clearMultipleFacets } = useTableViewHelpers();

  return (
    <FilterOptionItem
      preventClose={false}
      withCheckbox={false}
      onClick={() => clearMultipleFacets([facetName])}
      className='text-primary-800 cursor-pointer text-start text-sm p-2 ps-4 border-t border-pale-border hover:bg-primary-30'
    >
      Clear filters
    </FilterOptionItem>
  );
};
